import { Link } from 'react-router-dom';

function About() {
  return (
    <div className="py-20">
      <div className="container mx-auto px-4">
        {/* Hero */}
        <div className="text-center mb-16 max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            <span className="gradient-text">About Velumcloud</span>
          </h1>
          <p className="text-xl text-gray-400">
            Building the future of enterprise cloud security
          </p>
        </div>

        {/* Mission */}
        <div className="max-w-4xl mx-auto mb-20">
          <div className="card">
            <h2 className="text-3xl font-bold mb-6 text-white">Our Mission</h2>
            <p className="text-gray-400 text-lg mb-4">
              At Velumcloud, we believe that security should never be a barrier to productivity. 
              Our mission is to provide enterprise-grade security solutions that are both powerful 
              and easy to use, enabling organizations to embrace the cloud with confidence.
            </p>
            <p className="text-gray-400 text-lg">
              Founded by security experts with decades of combined experience, we understand the 
              challenges modern enterprises face in protecting their digital assets while maintaining 
              operational efficiency.
            </p>
          </div>
        </div>

        {/* Values */}
        <div className="mb-20">
          <h2 className="text-3xl font-bold text-center mb-12">
            <span className="gradient-text">Our Values</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="card text-center">
              <div className="w-16 h-16 bg-cyber-blue/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-cyber-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-white">Security First</h3>
              <p className="text-gray-400">
                We prioritize security in every decision, from product design to company culture.
              </p>
            </div>

            <div className="card text-center">
              <div className="w-16 h-16 bg-cyber-purple/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-cyber-purple" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-white">Customer Obsessed</h3>
              <p className="text-gray-400">
                Our customers' success is our success. We're here to support you every step of the way.
              </p>
            </div>

            <div className="card text-center">
              <div className="w-16 h-16 bg-cyber-green/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-cyber-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-white">Innovation</h3>
              <p className="text-gray-400">
                We're constantly pushing boundaries to deliver cutting-edge security solutions.
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="card text-center bg-gradient-to-r from-cyber-blue/10 via-cyber-purple/10 to-cyber-pink/10">
          <h2 className="text-3xl font-bold mb-4 text-white">Join Us on Our Mission</h2>
          <p className="text-gray-400 mb-6 max-w-2xl mx-auto">
            Whether you're looking for a security partner or want to join our team, we'd love to hear from you.
          </p>
          <Link to="/contact" className="btn-primary">
            Get in Touch
          </Link>
        </div>
      </div>
    </div>
  );
}

export default About;
